import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cinput() {

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
  return (
    <div>
       <Sides/>
       <Helmet>
 
 <title>Input in c programming language tutorial For Beginners</title>
 <meta name="description" content="input in c programming language tutorial for beginners.input in c programming language at run time scanf ( ) function is commonly used to input the value.string input in c CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,String input in c,tutorial for begineers,string input in c,c input,input in c programming language at run time,input in c,learn c programming language,learn code online,c input integer,c input and output,c input from keyboard,c user input integer,c input output,c input string,c input in c programming code" />
 <link rel="canonical" href="https://www.codeexampler.com/c-input" />
 </Helmet>

 <div className='lg:pl-56'>

      <h1 className="m-4 mh1">Input in a C Programming Language
</h1>
<div className="first">
        <a href="/c-first-program">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-literal">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
      <h2 className="mt-4 mh2">input in c programming language at run time:</h2>
      <p className="mt-4 para">The scanf ( ) function is commonly used to input the value. scanf ( ) receives from the keyboard.
</p>



      <h2 className='headings'>Q-Write a program to user input in string input in C programming example?</h2>
   <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
  <pre style={{maxHeight:"500vh"}}>
      <code >
        {"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">stdio.h</span>
            <span className="qwerty-3">&#62; </span>
        {"\n"}{"\n"}
            <span className="qwerty-5">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span> 
        {"\n"}{"\n"}
            <span className="qwerty-3" > &#123; </span>        
        {"\n"}{"\n"}
            <span className="qwerty-5">   int </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-2">//this declare a variable</span>        
        {"\n"}{"\n"}
            <span className="qwerty-5">   float </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-2">//this declare a variable</span>  
        {"\n"}{"\n"}
            <span className="qwerty-7">   printf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-10">enter value of a</span>
            <span className="qwerty-3">");</span>         
        {"\n"}{"\n"}
            <span className="qwerty-6">   scanf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-4">%d</span>
            <span className="qwerty-3">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">);</span>
        {"\n"}{"\n"}
            <span className="qwerty-7">   printf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-10">enter float value of b</span>
            <span className="qwerty-3">");</span>         
        {"\n"}{"\n"}
            <span className="qwerty-6">   scanf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-4">%d</span>
            <span className="qwerty-3">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-10">b </span>        
            <span className="qwerty-3">);</span>       
        {"\n"}{"\n"}
            <span className="qwerty-10">   return</span>
            <span className="qwerty-4"> 0</span>
            <span className="qwerty-3">; </span>
        {"\n"}{"\n"}
            <span className="qwerty-3">&#125;</span>
    </code>{"\n"}{"\n"}
    </pre>
    </div>   

      <h2 className="mt-4 mh2">Input in C Examples :</h2>



      <h2 className='headings'>Q-Write a program to input 3 numbers and print the total marks in C programming example?</h2>
   <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
  <pre style={{maxHeight:"500vh"}}>
      <code >
        {"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">stdio.h</span>
            <span className="qwerty-3">&#62; </span>
                    {"\n"}{"\n"}
            <span className="qwerty-5">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span> 
        {"\n"}{"\n"}
            <span className="qwerty-3" > &#123; </span>        
        {"\n"}{"\n"}
            <span className="qwerty-5">    int </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-10"> b</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-10"> c</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-10"> sum</span>
            <span className="qwerty-3">;</span> 
        {"\n"}{"\n"}
            <span className="qwerty-7">   printf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-10">enter first no</span>
            <span className="qwerty-8">\n</span>
            <span className="qwerty-3">");</span>         
        {"\n"}{"\n"}
            <span className="qwerty-6">   scanf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-4">%d</span>
            <span className="qwerty-3">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-10">a</span>        
            <span className="qwerty-3">);</span>
                    {"\n"}{"\n"}
            <span className="qwerty-6">   printf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-10">enter second no</span>
            <span className="qwerty-8">\n</span>
            <span className="qwerty-3">");</span>         
        {"\n"}{"\n"}
            <span className="qwerty-6">   scanf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-4">%d</span>
            <span className="qwerty-3">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-10">b </span>
            <span className="qwerty-3">);</span>
        {"\n"}{"\n"}
            <span className="qwerty-7">   printf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-10">enter third no</span>
            <span className="qwerty-8">\n</span>
            <span className="qwerty-3">");</span>         
        {"\n"}{"\n"}
            <span className="qwerty-6">   scanf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-4">%d</span>
            <span className="qwerty-3">",</span>
            <span className="qwerty-1">&amp;</span>
            <span className="qwerty-10">c </span>        
            <span className="qwerty-3">);</span>
        {"\n"}{"\n"}
            <span className="qwerty-10">   sum </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-10"> a </span>
            <span className="qwerty-11">+</span>
            <span className="qwerty-10"> b </span>
            <span className="qwerty-11">+</span>
            <span className="qwerty-10"> c</span>
            <span className="qwerty-3">;</span>
        {"\n"}{"\n"}
            <span className="qwerty-7">   printf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-4"> %d </span>
            <span className="qwerty-3">",</span>
            <span className="qwerty-10"> sum </span>
            <span className="qwerty-3">);</span>
        {"\n"}{"\n"}
            <span className="qwerty-10">   return</span>
            <span className="qwerty-4"> 0</span>
            <span className="qwerty-3">; </span>
        {"\n"}{"\n"}
            <span className="qwerty-3">&#125;</span>
    </code>{"\n"}{"\n"}
    </pre>
    </div>          
    <h4 className='headings'>Output :</h4>
     <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
            <code >
                
                {"\n"}
                    <span className="qwerty-4">enter first no </span>
                    <span className="qwerty-10">24 </span>
                {"\n"}{"\n"}
                    <span className="qwerty-4">enter second no </span>
                    <span className="qwerty-10"> 14 </span>
                {"\n"}{"\n"}
                    <span className="qwerty-4">enter third no </span>
                    <span className="qwerty-10"> 25 </span>
                {"\n"}{"\n"}
                    <span className="qwerty-10">sum = 63</span>
            </code>{"\n"}{"\n"}
            </pre>
            </div>  



      <h2 className='headings'>Q-Write a program to calculate and print simple interest  in C programming example?</h2>
  <div style={{background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
    <pre style={{ maxHeight:"500vh"}}>
      <code >
        {"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">stdio.h</span>
            <span className="qwerty-3">&#62; </span>
        {"\n"}{"\n"}
            <span className="qwerty-5">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span> 
        {"\n"}{"\n"}
            <span className="qwerty-3" > &#123; </span>        
        {"\n"}{"\n"}
            <span className="qwerty-5">   float </span>
            <span className="qwerty-10">p</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">r</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">t</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">si</span>
            <span className="qwerty-3">; </span> 
        {"\n"}{"\n"}
            <span className="qwerty-7">   printf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-10">enter the value of p</span>
            <span className="qwerty-3">");</span>         
        {"\n"}{"\n"}
            <span className="qwerty-6">   scanf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-4">%f</span>
            <span className="qwerty-3">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-10">p </span>
            <span className="qwerty-3">);</span>
                   {"\n"}{"\n"}
        <span className="qwerty-7">   printf</span>
        <span className="qwerty-3">("</span>
        <span className="qwerty-10">enter the value of r</span>
        <span className="qwerty-3">");</span>         
            {"\n"}{"\n"}
                <span className="qwerty-6">   scanf</span>
                <span className="qwerty-3">("</span>
                <span className="qwerty-4">%f</span>
                <span className="qwerty-3">",</span>
                <span className="qwerty-1"> &amp;</span>
                <span className="qwerty-10">r </span>
                <span className="qwerty-3">);</span>
        {"\n"}{"\n"}
    <span className="qwerty-7">   printf</span>
    <span className="qwerty-3">("</span>
    <span className="qwerty-10">enter the value of t</span>
    <span className="qwerty-3">");</span>         
        {"\n"}{"\n"}
            <span className="qwerty-6">   scanf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-4">%f</span>
            <span className="qwerty-3">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-10">t </span>
            <span className="qwerty-3">);</span>
        {"\n"}{"\n"}
            <span className="qwerty-10">   si </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-10"> p</span>
            <span className="qwerty-11">*</span>
            <span className="qwerty-10"> r</span>
            <span className="qwerty-11">*</span>
            <span className="qwerty-10"> t</span>
            <span className="qwerty-11">/</span>
            <span className="qwerty-10">100</span>
            <span className="qwerty-3">;</span>
        {"\n"}{"\n"}
            <span className="qwerty-7">   printf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-10">si = </span>
            <span className="qwerty-4">%f</span>
            <span className="qwerty-3">",</span>
            <span className="qwerty-10"> si</span>
            <span className="qwerty-3">");</span>                 
        {"\n"}{"\n"}
            <span className="qwerty-10">   return</span>
            <span className="qwerty-4"> 0</span>
            <span className="qwerty-3">; </span>
        {"\n"}{"\n"}
            <span className="qwerty-3">&#125;</span>
    </code>{"\n"}{"\n"}
    </pre>
    </div>    
    <h4 className='headings'>Output :</h4>
        <div style={{background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >
                    
                    {"\n"}
                        <span className="qwerty-4">enter the value of p </span>
                        <span className="qwerty-10">45 </span>
                    
                    {"\n"}{"\n"}
                        <span className="qwerty-4">enter the value of r </span>
                        <span className="qwerty-10"> 68 </span>
                                        {"\n"}{"\n"}
                        <span className="qwerty-4">enter the value of t </span>
                        <span className="qwerty-10"> 25 </span>
                                        {"\n"}{"\n"}
                        <span className="qwerty-10">si = 765.000000</span>
                    </code>{"\n"}{"\n"}
                </pre>
                </div> 

  

      <h2 className='headings'>Q-Write a program to find and print the area of rectangle in C programming example?</h2>
   <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
  <pre style={{maxHeight:"500vh"}}>
      <code >
        {"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">stdio.h</span>
            <span className="qwerty-3">&#62; </span>
        {"\n"}{"\n"}
            <span className="qwerty-5">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
        {"\n"}{"\n"}
            <span className="qwerty-3" > &#123; </span>
        {"\n"}{"\n"}
            <span className="qwerty-5">   int </span>
            <span className="qwerty-10">l</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">area</span>
            <span className="qwerty-3">; </span>
        {"\n"}{"\n"}
            <span className="qwerty-7">   printf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-10">enter a value of l </span>
            <span className="qwerty-3">");</span>
        {"\n"}{"\n"}
            <span className="qwerty-6">   scanf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-4">%d</span>
            <span className="qwerty-3">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-10">l </span>
            <span className="qwerty-3">);</span>
       {"\n"}{"\n"}
        <span className="qwerty-7">   printf</span>
        <span className="qwerty-3">("</span>
        <span className="qwerty-10">enter a value of b </span>
        <span className="qwerty-3">");</span>
            {"\n"}{"\n"}
                <span className="qwerty-6">   scanf</span>
                <span className="qwerty-3">("</span>
                <span className="qwerty-4">%d</span>
                <span className="qwerty-3">",</span>
                <span className="qwerty-1"> &amp;</span>
                <span className="qwerty-10">b </span>
                <span className="qwerty-3">);</span>
            {"\n"}{"\n"}
            <span className="qwerty-10">   area </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-10"> l </span>
            <span className="qwerty-11">*</span>
            <span className="qwerty-10"> b</span>
            <span className="qwerty-3">;</span>
        {"\n"}{"\n"}
            <span className="qwerty-7">   printf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-10">area = </span>
            <span className="qwerty-4">%d</span>
            <span className="qwerty-3">",</span>
            <span className="qwerty-10"> area</span>
            <span className="qwerty-3">");</span>
        {"\n"}{"\n"}
            <span className="qwerty-10">   return</span>
            <span className="qwerty-4"> 0</span>
            <span className="qwerty-3">; </span>
        {"\n"}{"\n"}
            <span className="qwerty-3">&#125;</span>
    </code>{"\n"}{"\n"}
    </pre>
    </div>  
    
    <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
          <pre style={{maxHeight:"100vh"}}>
                <code >
                    
                    {"\n"}
                        <span className="qwerty-4">enter a value of l </span>
                        <span className="qwerty-10">4 </span>
                                        {"\n"}{"\n"}
                        <span className="qwerty-4">enter the value of b </span>
                        <span className="qwerty-10"> 5 </span>                  
                    {"\n"}{"\n"}
                        <span className="qwerty-10">area = 20</span>
                </code>{"\n"}{"\n"}
                </pre>
                </div> 



      <h2 className='headings'>Q-Write a program to find out the value of pi and print area of a circle in C programming example?</h2>
   <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
  <pre style={{maxHeight:"500vh"}}>
      <code >
        {"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">stdio.h</span>
            <span className="qwerty-3">&#62; </span>
                {"\n"}{"\n"}
            <span className="qwerty-5">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
                {"\n"}{"\n"}
            <span className="qwerty-3" > &#123; </span>    
        {"\n"}{"\n"}
            <span className="qwerty-5">   float </span>
            <span className="qwerty-10">r</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">area</span>
            <span className="qwerty-3">; </span>
        {"\n"}{"\n"}
            <span className="qwerty-7">   printf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-10">enter a value of r </span>
            <span className="qwerty-3">");</span>
        {"\n"}{"\n"}
            <span className="qwerty-6">   scanf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-4">%f</span>
            <span className="qwerty-3">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-10">r </span>
            <span className="qwerty-3">);</span>
            {"\n"}{"\n"}
            <span className="qwerty-10">   area </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-9"> 3.14 </span>
            <span className="qwerty-11">*</span>
            <span className="qwerty-10"> r</span>
            <span className="qwerty-11">*</span>
            <span className="qwerty-10"> r</span>
            <span className="qwerty-3">;</span>
        {"\n"}{"\n"}
            <span className="qwerty-7">   printf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-10">area = </span>
            <span className="qwerty-4">%f</span>
            <span className="qwerty-3">",</span>
            <span className="qwerty-10"> area</span>
            <span className="qwerty-3">");</span>
        {"\n"}{"\n"}
            <span className="qwerty-10">   return</span>
            <span className="qwerty-4"> 0</span>
            <span className="qwerty-3">; </span>
    
        {"\n"}{"\n"}
            <span className="qwerty-3">&#125;</span>
    </code>{"\n"}{"\n"}
    </pre>
    </div>  
    
    <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
          <pre style={{maxHeight:"100vh"}}>
                <code >
                    
                    {"\n"}
                        <span className="qwerty-4">enter a value of r </span>
                        <span className="qwerty-10">2 </span>
                             {"\n"}{"\n"}
                        <span className="qwerty-10">area = 12.560000</span>
                        {"\n"}{"\n"}
                </code>
                </pre>
                </div> 

  
      <h2 className='headings'>Q-Write a program to 3 subject marks, add all values,and multiply all the values in C programming example?</h2>
   <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
  <pre style={{maxHeight:"500vh"}}>
      <code >
        {"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">stdio.h</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-5">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3" > &#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-5">   int </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">c</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">add</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-10">mult</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
            <span className="qwerty-7">   printf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-10">enter a value of a </span>
            <span className="qwerty-3">");</span>   
        {"\n"}{"\n"}
            <span className="qwerty-6">   scanf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-4">%d</span>
            <span className="qwerty-3">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">);</span>         
            {"\n"}{"\n"}
           <span className="qwerty-7">   printf</span>
           <span className="qwerty-3">("</span>
           <span className="qwerty-10">enter a value of b </span>
           <span className="qwerty-3">");</span>         
       {"\n"}{"\n"}
           <span className="qwerty-6">   scanf</span>
           <span className="qwerty-3">("</span>
           <span className="qwerty-4">%d</span>
           <span className="qwerty-3">",</span>
           <span className="qwerty-1"> &amp;</span>
           <span className="qwerty-10">b </span>
           <span className="qwerty-3">);</span>         
      {"\n"}{"\n"}
          <span className="qwerty-7">   printf</span>
          <span className="qwerty-3">("</span>
          <span className="qwerty-10">enter a value of c </span>
          <span className="qwerty-3">");</span>
      {"\n"}{"\n"}
          <span className="qwerty-6">   scanf</span>
          <span className="qwerty-3">("</span>
          <span className="qwerty-4">%d</span>
          <span className="qwerty-3">",</span>
          <span className="qwerty-1"> &amp;</span>
          <span className="qwerty-10">c </span>
          <span className="qwerty-3">);</span>
            {"\n"}{"\n"}
            <span className="qwerty-10">   add </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-10"> a </span>
            <span className="qwerty-11">+</span>
            <span className="qwerty-10"> b</span>
            <span className="qwerty-11">+</span>
            <span className="qwerty-10"> c</span>
            <span className="qwerty-3">;</span>
        {"\n"}{"\n"}
            <span className="qwerty-10">   mult </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-10"> a </span>
            <span className="qwerty-11">*</span>
            <span className="qwerty-10"> b</span>
            <span className="qwerty-11">*</span>
            <span className="qwerty-10"> c</span>
            <span className="qwerty-3">;</span>
        {"\n"}{"\n"}
            <span className="qwerty-7">   printf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-10">total = </span>
            <span className="qwerty-4">%d</span>
            <span className="qwerty-3">",</span>
            <span className="qwerty-10"> add</span>
            <span className="qwerty-3">");</span>
        {"\n"}{"\n"}
            <span className="qwerty-7">   printf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-10">multiply = </span>
            <span className="qwerty-4">%d</span>
            <span className="qwerty-3">",</span>
            <span className="qwerty-10"> mult</span>
            <span className="qwerty-3">");</span>
        {"\n"}{"\n"}
            <span className="qwerty-10">   return</span>
            <span className="qwerty-4"> 0</span>
            <span className="qwerty-3">; </span>
        {"\n"}{"\n"}
            <span className="qwerty-3">&#125;</span>
    </code>{"\n"}{"\n"}
    </pre>
    </div>  
    
    <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
          <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-4">enter a value of a </span>
                        <span className="qwerty-10">2 </span>
                    {"\n"}{"\n"}
                        <span className="qwerty-4">enter a value of b </span>
                        <span className="qwerty-10">4 </span>
                    {"\n"}{"\n"}
                        <span className="qwerty-4">enter a value of c </span>
                        <span className="qwerty-10">6 </span>
                    {"\n"}{"\n"}
                        <span className="qwerty-10">total = 12</span>                    
                    {"\n"}{"\n"}
                        <span className="qwerty-10">multiply = 48</span>
                </code>{"\n"}{"\n"}
                </pre>
                </div>    


      <h1 className="mt-5">  </h1>
      <div className="back">
        <a href="/c-first-program">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-literal">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
  )

}
export default Cinput;